import { render, staticRenderFns } from "./HolidayOverview.vue?vue&type=template&id=27f3b940&scoped=true"
import script from "./HolidayOverview.vue?vue&type=script&lang=js"
export * from "./HolidayOverview.vue?vue&type=script&lang=js"
import style0 from "./HolidayOverview.vue?vue&type=style&index=0&id=27f3b940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f3b940",
  null
  
)

export default component.exports